import React from 'react';
import FormattedBox from '../../components/FormattedBox'
import * as Filters from '../../helpers/Filters'
import * as Formatting from 'fw/misc/Formatting'
import * as Parsing from 'fw/misc/Parsing'

class DecimalBox extends React.Component {

	// Public
	setValue = (value) => { this._input.setValue(value); }
	getValue = () => { this._input.getValue(); }
	focus = () => { this._input.focus(); }
	select = () => { this._input.select(); }
	flag = (status) => { this._input.flag(status); }
	completed = () => { return this._input.completed(); }
	validate = () => { return this._input.validate(); }

	// Private
	_format = (value) => {
		return Formatting.formatDecimal(value, this.props.precision);
	}

	_parse = (value) => {
		return Parsing.parseDecimal(value);
	}

	_filter = (key) => {
		return Filters.numbersOnly(key);
	}

	// React
	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value
			|| nextProps.disabled !== this.props.disabled);
	}

	render() {
		const props = {
			...this.props,
			formatter: this._format,
			parser: this._parse,
			filter: this._filter,
			className: this.props.className + " text-right"
		}

		return (<FormattedBox {...props} ref={(input) => this._input = input} />)
	}
}

export default DecimalBox;

// Mark this as a form component
DecimalBox.defaultProps = {
	formControl: true,
	managed: false,
	maxLength: 10,
	precision: 2
};



// WEBPACK FOOTER //
// ./src/fw/forms/controls/decimalBox/DecimalBox.js